export const UPDATE_SELECT_ROW_PEOPLE = 'UPDATE_SELECT_ROW_PEOPLE'
export const UPDATE_SELECT_ROW = 'UPDATE_SELECT_ROW'
export const UPDATE_OPEN_MODAL_ADD_PEOPLE = 'UPDATE_OPEN_MODAL_ADD_PEOPLE'
export const UPDATE_TAG_DETAIL_DATA = 'UPDATE_TAG_DETAIL_DATA'
export const UPDATE_TAG_DETAIL_LOADING = 'UPDATE_TAG_DETAIL_LOADING'
export const CLEAR_PEOPLE_TO_TAG = 'CLEAR_PEOPLE_TO_TAG'